import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'

export const products = {
  getProducts,
  getProductComponents,
  getProductVariations,
  getProductsTier,
  getProductsCatalogue
}

async function getProducts() {
  try {
    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/products',
      withAccessToken: true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getProducts: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getProductsCatalogue({order_catalog_id}) {
  try {
    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/products',
      withAccessToken: true,
      queryParams:{
        order_catalog_id
      }
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getProducts: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}


async function getProductComponents(prodId) {
  try {
    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/products/' + prodId + '/components',
      withAccessToken: true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getProducts: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getProductVariations(prodId) {
  try {
    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/products/' + prodId + '/variations',
      withAccessToken: true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getProducts: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getProductsTier({
  prodId,
  change_type,
  page = 1,
  size = 10,
  contact_id,
}) {
  try {
    //console.log('API: ', contact)
    if(!contact_id) contact_id = await httpUtil.getSession().sub;
    let response = await httpUtil.get({
      resourcePath: '/v1/products/' + prodId + '/tiering',
      withAccessToken: true,
      queryParams: {
        page,
        size,
        change_type,
        contact_id,
      },
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getProductsTier: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}




